import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/digital-democracy")({
  beforeLoad: () => {
    throw redirect({
      to: "/$languageKey/$topicSlug/$pageSlug",
      params: {
        languageKey: "en",
        topicSlug: "democracy",
        pageSlug: "digital-democracy",
      },
      statusCode: 301,
    });
  },
});
